<section id="section-category" [ngClass]="{ popup: isPopup }">
  @if(isPopup) {
  <div class="mask" (click)="back.emit()">
    <div class="close-section">
      <i class="close-btn icon-close" (click)="back.emit()"></i>
    </div>
  </div>
  }
  <div [ngClass]="{ popupbg: isPopup }">
    <div class="section-category-bg">
      <div class="section-category-title">
        {{ 'CATEGORY.TITLE' | translate }}
      </div>
      <div class="section-category-list">
        <ng-container
          *ngTemplateOutlet="categoryList; context: { $implicit: categories }"
        ></ng-container>
      </div>
    </div>
    <lynx-amusement [inCategory]="true"></lynx-amusement>
  </div>
</section>

<ng-template #categoryList let-categories>
  <ul dragScroll class="category-container">
    @for(category of categories; track category.categoryId; let i = $index) {
    <li class="category-list" id="category-{{ i + 1 }}">
      <ng-container
        *ngTemplateOutlet="
          hasSubCategories(category) ? nestedCategory : singleCategory;
          context: { $implicit: category }
        "
      ></ng-container>
    </li>
    }
  </ul>
</ng-template>

<ng-template #nestedCategory let-category>
  <div
    [class]="{
      'category-link': isRootCategory(category),
      active: isChildSelected(category)
    }"
    [class.is-mobile]="isMobile"
    (click)="onExpandCategory(category, $event)"
    (mouseenter)="onMouseEnterCategory(category, $event)"
    (mouseleave)="onMouseLeaveCategory(category, $event)"
  >
    <div class="category-wrapper">
      <lottie-player
        [id]="category.categoryId"
        class="category-icon"
        [ngClass]="{ 'category-icon--static': !isAnimatedIconType(category.icon) }"
        [attr.src]="getIconAssetPath(category)"
      ></lottie-player>

      <span class="category-title">{{ category.categoryName }}</span>

      <span
        class="category-arrow"
        [ngClass]="[isChildSelected(category) ? 'icon-top' : 'icon-down']"
      ></span>
    </div>
  </div>

  @if(isChildSelected(category)) {
  <ng-container
    *ngTemplateOutlet="
      categoryList;
      context: { $implicit: category.subCategories }
    "
  ></ng-container>
  }
</ng-template>

<ng-template #singleCategory let-category>
  <div
    class="category-link"
    [class.is-mobile]="isMobile"
    [class.active]="
      isRootCategory(category) && selectedCategoryId === category.categoryId
    "
    [class.selected]="
      !isRootCategory(category) && selectedCategoryId === category.categoryId
    "
    (click)="onCategoryClick(category, $event)"
    (mouseenter)="onMouseEnterCategory(category, $event)"
    (mouseleave)="onMouseLeaveCategory(category, $event)"
  >
    <div class="category-wrapper">
      @if (isRootCategory(category) || hasSubCategories(category)) {
        <lottie-player
          [id]="category.categoryId"
          class="category-icon"
          [ngClass]="{ 'category-icon--static': !isAnimatedIconType(category.icon) }"
          [attr.src]="getIconAssetPath(category)"
        ></lottie-player>
      }

      <span
        class="category-title"
        [ngClass]="{
          'category-title--sub-category':
            !hasSubCategories(category) && !isRootCategory(category)
        }"
        >{{ category.categoryName }}</span
      >
    </div>
  </div>
</ng-template>
